import graphql__6762651c660cadd0d9bc from "./__generated__/ContributionsMapContributionsFragment_participativeModule.graphql.js";import { graphql } from "react-relay";

// This fragment is used to refetch filtered data for contributions list with navigation
// to ensure that both the navigation cards and the list contributions details are
// actually reloaded when the connection is refetched after filters are changed
//
export const ContributionsMapContributionsFragment_participativeModule = graphql__6762651c660cadd0d9bc;
